export default function uibDropdownToggleInput($window, $timeout) {
  'ngInject';

  return {
    require: '^?uibDropdown',
    restrict: 'A',
    link($scope, $element, $attrs, $ctrl) {
      let mousedown;
      const onFocusin = (e) => {
        if (mousedown) {
          return;
        }

        if (e.target === $element[0]) {
          $scope.$evalAsync(() => {
            if (!$ctrl.isOpen()) {
              $ctrl.toggle();
            }
          });
        } else if (/(input|textarea)/i.test(e.target.tagName)) {
          $scope.$evalAsync(() => {
            if ($ctrl.isOpen()) {
              $ctrl.toggle();
            }
          });
        }
      };

      if ($element[0].tagName === 'INPUT' && $ctrl) {
        $window.addEventListener('focusin', onFocusin);
        $scope.$on('$destroy', () => {
          $window.removeEventListener('focusin', onFocusin);
        });

        $element.on('mousedown', () => {
          mousedown = true;
          $timeout(
            () => {
              mousedown = false;
            },
            500,
            false
          );
        });
      }
    },
  };
}
